import { EventBus, Events } from "jiffy-store";
import initSampleInfoTooltips from "components/jiffy/sample-info-tooltip/sample-info-tooltip";

// PIP-3358: on the canonical-URL surface the color lives in the DOM, not ?ac=.
const resolveActiveColor = () =>
  document.getElementById("active-color-name")?.value ||
  new URLSearchParams(window.location.search).get("ac");

const buildSampleRedirectPath = activeColor => {
  const currentUrl = new URL(
    window.location.pathname + window.location.search,
    window.location.origin
  );
  currentUrl.searchParams.set("sample", "true");
  if (activeColor && !currentUrl.searchParams.get("ac")) {
    currentUrl.searchParams.set("ac", activeColor);
  }
  return encodeURIComponent(currentUrl.pathname + currentUrl.search);
};

const initColorChangeHandler = () => {
  EventBus.on(Events.PRODUCT_COLOR_SELECTED, () => {
    const activeColor = resolveActiveColor();
    const nextPage = buildSampleRedirectPath(activeColor);

    // Update sample link for logged-in users only
    const $sampleLink = document.querySelector(".js-sample-request-link");
    if ($sampleLink && !$sampleLink.classList.contains("js-sign-in-modal-toggle")) {
      // Only update if it's NOT a guest user (guest users have js-sign-in-modal-toggle class)
      // searchParams.set("ac", null) would write a literal "ac=null" into the
      // sample link — resolve DOM-first and only set when a color is present.
      const url = new URL($sampleLink.href, window.location.origin);
      if (activeColor) {
        url.searchParams.set("ac", activeColor);
      }
      // eslint-disable-next-line no-param-reassign
      $sampleLink.href = url.pathname + url.search;
    }

    // Update sign-in modal form action
    const $signInForm = document.querySelector(".js-sign-in-modal-form-in");
    if ($signInForm) {
      $signInForm.action = $signInForm.action.replace(
        /(redirect_to=)([^&]*)/gi,
        `redirect_to=${nextPage}`
      );
    }

    // Update sign-up modal form action
    const $signUpForm = document.querySelector(".js-sign-in-modal-form-up");
    if ($signUpForm) {
      $signUpForm.action = $signUpForm.action.replace(
        /(redirect_to=)([^&]*)/gi,
        `redirect_to=${nextPage}`
      );
    }
  });
};

let isInitProductRequestSampleInited = false;

const initProductRequestSample = () => {
  if (!isInitProductRequestSampleInited) {
    isInitProductRequestSampleInited = true;
    initSampleInfoTooltips();
    initColorChangeHandler();
  }
};

export default initProductRequestSample;
